import cloneDeep from 'lodash/cloneDeep'
import extend from 'lodash/extend'
import * as yup from 'yup'

import './form.module.scss'

import {
	bankNames,
	counties,
	countries,
	employmentSchemes,
	genders,
	heardAboutSources,
	nationalities,
	pronouns,
	foodSafetyCertificateLevels,
} from '@server/constants'
import { AdminModel } from '@modules/user/user.module'

import FieldGroup from './components/FieldGroup'
import FormField from './components/FormField'
import FormGroup from './components/FormGroup'

export { FieldGroup, FormGroup, FormField }

const yearInMilliseconds = 31536000000;

const isTrue = (value) => value === true || value === 'true';

const getYesNoOptions = () => ([
	{value: true, label: 'Yes'},
	{value: false, label: 'No'}
]);

const _fieldPresets = {


	// --- can't remove yet 
	// (used in fieldArray fields directly!)

	'companyAddress.line1': {
		label: 'Address Line 1',
		name: 'companyAddress.line1',
		type: 'text',		
	},
	'companyAddress.line2': {
		label: 'Address Line 2',
		name: 'companyAddress.line2',
		type: 'text',
	},
	'companyAddress.townCity': {
		label: 'Town / City',
		name: 'companyAddress.townCity',
		type: 'text',
	},
	'companyAddress.country': {
		label: 'Country',
		name: 'companyAddress.country',
		component: 'Select',
		options: makeOptions(countries),
	},
	'companyAddress.postCode': {
		label: 'Post Code',
		name: 'companyAddress.postCode',
		type: 'text',
	},
	  // Referee fields
	'referee.name': {
		label: 'Referee Name',
		name: 'referee.name',
		type: 'text',
	},
	'referee.position': {
		label: 'Referee Position',
		name: 'referee.position',
		type: 'text',
	},
	'referee.telephone': {
		label: 'Referee Telephone',
		name: 'referee.telephone',
		type: 'text',
	},
	'referee.email': {
		label: 'Referee E-mail',
		name: 'referee.email',
		type: 'text',
	},

	companyName: {
		label: 'Company Name',
		name: 'companyName',
		type: 'text',
	},
  position: {
  	label: 'Position Held',
		name: 'position',
		type: 'text',
  },
  'datesWorked.from': {
  	label: 'Date Worked From (dd/mm/yyyy)',
		name: 'datesWorked.from',
		component: 'DatePicker'
  },
  'datesWorked.to': {
  	label: 'Date Worked Until (dd/mm/yyyy)',
		name: 'datesWorked.to',
		component: 'DatePicker'
  },
  duties: {
  	label: 'Duties',
		name: 'duties',
		component: 'textarea',
  },
  reasonsForLeaving: {
  	label: 'Reason(s) for Leaving',
		name: 'reasonsForLeaving',
  	component: 'textarea',
  },


	// ---



	profileImage: {
		label: "Profile Image",
		name: "profileImage",
		component: "FileUpload",
	},
	documents: {
		label: "Documents",
		name: "documents",
		component: "FileUploadMulti",
	},
	status: {
		label: "Status",
		name: "status",
		component: "Select",
		options: []
	},
	'name.title': {
		label: 'Title',
		name: 'name.title',
		component: 'Select',
		options: makeOptions(pronouns),
	},
	'name.first': {
		label: 'First Name',
		name: 'name.first',
		type: 'text',
	},
	'name.middle': {
		label: 'Middle Name(s)',
		name: 'name.middle',
		type: 'text',
	},
	'name.last': {
		label: 'Last Name',
		name: 'name.last',
		type:"text",
	},
	email: {
		label: 'E-mail Address',
		name: 'email',
		type: "text",
	},
	payrollNo: {
		label: "Payroll No.",
		name: "payrollNo",
		type: "number",
	},
	password: {
		label: "New Password",
		name: "password",
		type: "password",
	},
	passwordConfirm: {
		label: "Confirm New Password",
		name: "passwordConfirm",
		type: "password",
	},
	role: {
		label: "Role",
		name: "role", 
		component: "Select",
		options: [
			{ label: 'Super Admin', value: 'superadmin' },
			{ label: 'Consultant', value: 'consultant' },
		],
	},
	// Address fields
	'address.line1': {
		label: 'Address Line 1',
		name: 'address.line1',
		type: 'text',
	},
	'address.line2': {
		label: 'Address Line 2',
		name: 'address.line2',
		type: 'text',
	},
	'address.townCity': {
		label: 'Town / City',
		name: 'address.townCity',
		type: 'text',
	},
	'address.county': {
		label: 'County',
		name: 'address.county',
		component: 'Select',
		options: makeOptions(counties),
	},
	'address.postCode': {
		label: 'Post Code',
		name: 'address.postCode',
		type: 'text',
	},
	'address.country': {
		label: 'Country',
		name: 'address.country',
		component: 'Select',
		options: makeOptions(countries),
	},
	consultant: {
		label: 'Assigned Consultant',
		name: 'consultant',
		component: 'ResourceSelect',
		resource: 'admin',
		isMulti: false,
	},

	bio: {
		label: 'Bio',
		name: 'bio',
		component: 'textarea',
	},

	clientID: {
		label: 'Client ID',
		name: 'clientID',
		type: 'text',
	},
	clientName: {
		label: 'Client Name',
		name: 'clientName',
		type: 'text',
	},
	contacts: {
		label: '',
		name: 'contacts',
		component: 'Contacts'
	},
	factored: {
		label: 'Factored / Non Factored',
		name: 'factored',
		component: 'RadioGroup',
		options: [
			{value: true, label: "Factored"},
			{value: false, label: "Non Factored"},
		]
	},
	AWRApplicable: {
		label: 'AWR Applicable',
		name: 'AWRApplicable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},

	holidayPayRate: {
		label: 'Bank Holiday Pay Rate',
		name: 'holidayPayRate',
		type: 'number'
	},

	jobTypeRates: {
		label: '',
		name: 'jobTypeRates',
		component: 'JobTypeRates',
	},
	workingRequirements: {
		label: 'Working Requirements',
		name: 'workingRequirements',
		component: 'textarea',
	},
	mobile: {
  	label: 'Mobile Number',
		name: 'mobile',
		type: 'text',
  },
	jobType: {
		label: "Job Type",
		name: "jobType", 
		component: "ResourceSelect",
		resource: 'jobtype',
		isMulti: false,
	},
	client: {
		label: "Client",
		name: "client", 
		component: "ResourceSelect",
		resource: 'client',
		isMulti: false,
	},
	startDate: {
		label: "Start Date",
		name: "startDate", 
		component: "DatePicker",
	},
	gender: {
		label: 'Gender',
		name: 'gender',
		component: 'RadioGroup',
		options: makeOptions(genders),
	},
	jobTypes: {
		label: 'Job Types',
		name: 'jobTypes',
		component: 'ResourceSelect',
		resource: 'jobtype',
		isMulti: true,
	},
	candidate: {
		label: "Candidate",
		name: "candidate", 
		component: "ResourceSelect",
		resource: 'candidate',
		isMulti: false,
	},
	taxWeek: {
		label: 'Tax Week',
		name: 'taxWeek',
		type: 'number',
	},
	// National Identity Card
	nationalIdentityCardAvailable: {
		label: 'Do you have a National Identity Card?',
		name: 'nationalIdentityCardAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	nationalIdentityCardNumber: {
		label: 'National Identity Card Number',
		name: 'nationalIdentityCardNumber',
		type: 'text',
		show: ({ values }) => values && isTrue(values.nationalIdentityCardAvailable)
	},
	nationalIdentityCardExpiry: {
		label: 'National Identity Card Expiry',
		name: 'nationalIdentityCardExpiry',
		component: 'DatePicker',
		minDate: new Date(),
		show: ({ values }) => values && isTrue(values.nationalIdentityCardAvailable)
	},
	// Passport
	passportAvailable: {
		label: 'Do you have a Passport?',
		name: 'passportAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	passportID: {
		label: 'Passport ID',
		name: 'passportID',
		type: 'text',
		show: ({ values }) => values && isTrue(values.passportAvailable)
	},
	passportExpiry: {
		label: 'Passport Expiry Date',
		name: 'passportExpiry',
		component: 'DatePicker',
		minDate: new Date(),
		show: ({ values }) => values && isTrue(values.passportAvailable)
	},
	// Visa
	visaAvailable: {
		label: 'Do you have an Entry Visa?',
		name: 'visaAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	visaID: {
		label: 'Visa ID',
		name: 'visaID',
		type: 'text',
		show: ({ values }) => values && isTrue(values.visaAvailable)
	},
	visaExpiry: {
		label: 'Visa Expiry Date',
		name: 'visaExpiry',
		component: 'DatePicker',
		minDate: new Date(),
		show: ({ values }) => values && isTrue(values.visaAvailable)
	},
	// BRP
	BRPAvailable: {
		label: 'Do you have a Biometric Residence Permit (BRP)?',
		name: 'BRPAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	BRPID: {
		label: 'BRP ID',
		name: 'BRPID',
		type: 'text',
		show: ({ values }) => values && isTrue(values.BRPAvailable)
	},
	BRPExpiry: {
		label: 'BRP Expiry Date',
		name: 'BRPExpiry',
		component: 'DatePicker',
		minDate: new Date(),
		show: ({ values }) => values && isTrue(values.BRPAvailable)
	},
	// Birth Certificate
	birthCertificateAvailable: {
		label: 'Do you have a British Birth Certificate?',
		name: 'birthCertificateAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	birthCertificateID: {
		label: 'UK Birth Certificate ID',
		name: 'birthCertificateID',
		type: 'text',
		show: ({ values }) => values && isTrue(values.birthCertificateAvailable)
	},
	NINumberAvailable: {
		label: 'National Insurance Number Available?',
		name: 'NINumberAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	NINumber: {
		label: 'National Insurance Number',
		name: 'NINumber',
		type: 'text',
		show: ({ values }) => values && isTrue(values.NINumberAvailable)
	},
	nationality: {
		label: 'Nationality',
		name: 'nationality',
		component: 'Select',
		options: makeOptions(nationalities),
	},

	heardAboutHumanOne: {
  	label: 'How did you hear about Human One?',
		name: 'heardAboutHumanOne',
		component: 'Select',
		options: makeOptions(heardAboutSources),
  },

  countryOfBirth: {
		label: "Country of Birth",
		name: 'countryOfBirth',
		component: 'Select', 
		options: makeOptions(countries),
	},
	townCityOfBirth: {
		label: 'Town/City of Birth',
		name: 'townCityOfBirth',
		type: 'text',
	},
	regionOfBirth: {
		label: 'Region of Birth',
		name: 'regionOfBirth',
		type: 'text',
	},

	mothersMaidenName: {
		label: 'Mother\'s Maiden Name',
		name: 'mothersMaidenName',
		type: 'text',
	},
	nationalityChangedSinceBirth: {
		label: 'Nationality changed since birth?',
		name: 'nationalityChangedSinceBirth',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	birthNationality: {
		label: 'Previous nationality',
		name: 'birthNationality',
		component: 'Select',
		options: makeOptions(nationalities),
		show: ({ values }) => values && isTrue(values.nationalityChangedSinceBirth),
	},
	dateNationalityChanged: {
		label: 'Date Nationality Changed',
		name: 'dateNationalityChanged',
		component: 'DatePicker',
		maxDate: new Date(),
		show: ({ values }) => values && isTrue(values.nationalityChangedSinceBirth)
	},
	surnameChangedSinceBirth: {
		label: 'Surname changed since birth?',
		name: 'surnameChangedSinceBirth',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	previousSurname: {
		label: 'Previous Surname',
		name: 'previousSurname',
		type: 'text',
		show: ({ values }) => values && isTrue(values.surnameChangedSinceBirth)
	},
	dateSurnameChanged: {
		label: 'Date Surname Changed',
		name: 'dateSurnameChanged',
		component: 'DatePicker',
		maxDate: new Date(),
		show: ({ values }) => values && isTrue(values.surnameChangedSinceBirth)
	},
	drivingLicenceAvailable: {
		label: 'Driving Licence available?',
		name: 'drivingLicenceAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	drivingLicenceNumber: {
		label: 'Driving Licence Number',
		name: 'drivingLicenceNumber',
		type: 'text',
		show: ({ values }) => values && isTrue(values.drivingLicenceAvailable)
	},
	
	// SIA Licence
	SIALicenceAvailable: {
		label: 'SIA Licence Available?',
		name: 'SIALicenceAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	SIALicenceType: {
		label: 'SIA Licence Type',
		name: 'SIALicenceType',
		type: 'text',
		show: ({ values }) => values && isTrue(values.SIALicenceAvailable)
	},
	// Food Safety Certificate
	foodSafetyCertificateAvailable: {
		label: 'Food Safety Certificate Available?',
		name: 'foodSafetyCertificateAvailable',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	foodSafetyCertificateLevel: {
		label: 'Food Safety Certificate Level',
		name: 'foodSafetyCertificateLevel',
		component: 'Select',
		options: makeOptions(foodSafetyCertificateLevels),
		show: ({ values }) => values && isTrue(values.foodSafetyCertificateAvailable)
	},
	hasUnspentConvictions: {
		label: 'Has unspent criminal convictions?',
		name: 'hasUnspentConvictions',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	convictionsDescription: {
  	label: 'Convictions description',
		placeholder: 'Detail conviction(s) and date(s)',
		name: 'convictionsDescription',
		component: 'textarea',
		show: ({ values }) => values && isTrue(values.hasUnspentConvictions),
  },
  interviewResults: {
		name: 'interviewResults',
		component: 'InterviewResults',
	},
	dateOfBirth: {
		label: 'Date of Birth',
		name: 'dateOfBirth',
		component: 'DatePicker',
		maxDate: new Date(),
	},
	immigrationPermission: {
		label: 'Do you have immigration permission to work in the UK?',
		component: 'RadioGroup',
		name: 'immigrationPermission',
		options: getYesNoOptions(),
	},
	addressHistory: {
		label: '',
		name: 'addressHistory',
		component: 'AddressHistory',
	},
	// Payment details
  'paymentDetails.available': {
  	label: 'Bank account available?',
  	name: 'paymentDetails.available',
  	component: 'RadioGroup',
		options: getYesNoOptions(),
  },
  'paymentDetails.bankName': {
  	label: 'Bank Name',
		name: 'paymentDetails.bankName',
		component: 'Select',
		options: makeOptions(bankNames),
		show: ({ values }) => values && values.paymentDetails && isTrue(values.paymentDetails.available),
  },
  'paymentDetails.bankNameCustom': {
  	label: 'Custom Bank Name',
		name: 'paymentDetails.bankNameCustom',
		type: 'text',
		show: ({ values }) => 
			(values && values.paymentDetails)
			&& isTrue(values.paymentDetails.available)
			&& values.paymentDetails.bankName === "Other"
		,
  },
  'paymentDetails.accountHolderName': {
  	label: 'Account Holder Name',
		name: 'paymentDetails.accountHolderName',
		type: 'text',
		show: ({ values }) => values && values.paymentDetails && isTrue(values.paymentDetails.available),
  },
  'paymentDetails.sortCode': {
  	label: 'Sort Code',
		name: 'paymentDetails.sortCode',
		type: 'text',
		show: ({ values }) => values && values.paymentDetails && isTrue(values.paymentDetails.available),
  },
  'paymentDetails.accountNumber': {
  	label: 'Account Number',
		name: 'paymentDetails.accountNumber',
		type: 'text',
		show: ({ values }) => values && values.paymentDetails && isTrue(values.paymentDetails.available),
  },
  employmentHistory: {
		label: '',
		name: 'employmentHistory',
		component: 'EmploymentHistory',
	},	
  telephone: {
  	label: 'Phone Number',
		name: 'telephone',
		type: 'text',
  },
  previousAgencies: {
  	label: 'Previous agencies',
		name: 'previousAgencies',
		placeholder: 'Please detail',
		component: 'textarea',
  },
  // Emergency Contact
  'emergencyContact.name': {
  	label: 'Emergency Contact Name',
		name: 'emergencyContact.name',
		type: 'text',
  },
  'emergencyContact.relationship': {
  	label: 'Emergency Contact Relationship',
		name: 'emergencyContact.relationship',
		type: 'text',
  },
  'emergencyContact.telephone': {
  	label: 'Emergency Contact Telephone',
		name: 'emergencyContact.telephone',
		type: 'text',
  },
  'emergencyContact.mobile': {
  	label: 'Emergency Contact Mobile',
		name: 'emergencyContact.mobile',
		type: 'text',
  },
	// Client pay details
	jobsApplyingFor: {
		label: 'Jobs applying for',
		name: 'jobsApplyingFor',
		type: 'text',
	},
	employmentScheme: {
		label: 'Employment Scheme',
		name: 'employmentScheme',
		component: 'RadioGroup',
		options: makeOptions(employmentSchemes)
	},
	UTRNumber: {
		label: 'UTR Number',
		name: 'UTRNumber',
		type: 'text',
		show: ({ values }) => values && values.employmentScheme === "Self Employed",
	},
	availability: {
		label: 'Availability',
		name: 'availability',
		component: 'Availability',
	},
	optOut48HourWorkingWeek: {
		component: 'Checkbox', 
		name: 'optOut48HourWorkingWeek',
		value: 'I wish to opt-out of the 48 Hour Working Week Agreement',
	},
	hasHealthIssues: {
		label: 'Has relevant health issues',
		name: 'hasHealthIssues',
		component: 'RadioGroup',
		options: getYesNoOptions(),
	},
	healthIssuesDescription: {
		label: 'Health Issues Description',
		name: 'healthIssuesDescription',
		component: 'textarea',
		show: ({ values }) => values && isTrue(values.hasHealthIssues),
	},
	assistanceRequired: {
		label: 'Assistance required',
		name: 'assistanceRequired',
		component: 'textarea',
		show: ({ values }) => values && isTrue(values.hasHealthIssues),
	},
	equalOpportunitiesAgreement: {
		label: 'Equal Opportunities Agreement agreed',
		value: 'Equal Opportunities Agreement agreed',
		name: 'equalOpportunitiesAgreement',
		component: 'Checkbox'
	},
	dataProtectionAgreementPart1: {
		label: 'Data Protection Agreement part 1 agreed',
		value: 'Data Protection Agreement part 1 agreed',
		name: 'dataProtectionAgreementPart1',
		component: 'Checkbox'
	},
	dataProtectionAgreementPart2: {
		label: 'Data Protection Agreement part 2 agreed',
		value: 'Data Protection Agreement part 2 agreed',
		name: 'dataProtectionAgreementPart2',
		component: 'Checkbox'
	},
	candidateSigned: {
		label: 'Candidate Signed as',
		name: 'candidateSigned',
		type: 'text'
	},

}

const _filterPresets = {
	status: {
		component: 'Select',
		name: 'status',
		label: 'Status',
		nullValue: 'any',
	},
	search: {
		component: 'DebounceInput',
		name: 'search',
		label: 'Search',
		nullValue: '',
		minLength: 1,
		debounceTimeout: 1000,
	},
	employmentScheme: {
		component: 'Select',
		name: 'employmentScheme',
		label: 'Employment Scheme',
		nullValue: 'any',
		options: [
			{ label: 'All', value: 'any' },
			...makeOptions(employmentSchemes),
		]
	},
	role: {
		component: 'Select',
		name: 'role',
		label: 'Role',
		nullValue: 'any',
		options: [
			{ label: 'All', value: 'any' },
			...AdminModel.field('role').getFieldProps().options
		]
	},
	client: {
		component: 'ResourceIDSelect',
		name: 'client',
		label: 'Client',
		resource: 'client',
		nullValue: null,
	},
	approvedBy: {
		component: 'ResourceIDSelect',
		name: 'approvedBy',
		label: 'Approved By',
		resource: 'admin',
		nullValue: null,
	},
	jobType: {
		component: 'ResourceIDSelect',
		name: 'jobType',
		label: 'Job Type',
		resource: 'jobtype',
		nullValue: null,
	},
	taxWeek: {
		type: 'number',
		name: 'taxWeek',
		label: 'Tax Week',
		nullValue: '',
	},
	payrollNo: {
		type: 'number',
		name: 'payrollNo',
		label: 'Payroll No.',
		nullValue: '',
	},
}

yup.setLocale({
  mixed: {
  	// TODO: give better error
    required: 'This field is required',
  },
  string: {
  	// eslint-disable-next-line
    min: "Must be at least ${min} characters long",
    // eslint-disable-next-line
    max: "Must be less than ${max} characters",
    email: 'Invalid email address',
  },
});

const address = yup.object().shape({
	line1: yup.string().required(),
	line2: yup.string(),
	townCity: yup.string().required(),
	county: yup.string().oneOf(counties, 'County is required').required(),
	postCode: yup.string()
});

const addressWithCountry = yup.object().shape({
	line1: yup.string(),
	line2: yup.string(),
	townCity: yup.string(),
	country: yup.string().oneOf(['', ...countries], 'This field is required'),
	postCode: yup.string()
});

const addressWithCountryRequired = yup.object().shape({
	line1: yup.string().required(),
	line2: yup.string(),
	townCity: yup.string().required(),
	country: yup.string().oneOf(countries, 'This field is required'),
	postCode: yup.string()
});

const email = yup.string().email();
const telephone = yup.number();
const fullName = yup.string();
const date = yup.string().nullable();

const isTrueRequire = { is: true, then: s => s.required() }


const sortCodeTest = {
	name: "sort-code-validation",
	message: "Invalid sort code",
	test: function (value) {
		const regex = /(^[0-9]{2}-[0-9]{2}-[0-9]{2}$|^[0-9]{6}$)/i;
		return regex.test(value);
	}
}

export const validatorPresets = {
	date,
	taxWeek: yup.number().min(1).max(52).required(),
	payrollNo: yup.number(),
	// user specific
	telephone,
	fullName,
	email,
	address,
	password: yup.string().min(8),
	passwordConfirm: yup.string().when('password', {
		is: (password) => password && password.length,
		then: yup.string().required('Confirm New Password is required').oneOf([yup.ref('password')], 'Passwords do not match')
	}),
	name: yup.object().shape({
		title: yup.string(),
		first: yup.string().min(2).max(50).required(),
		middle: yup.string(),
		last: yup.string().min(2).max(50).required(),
	}),
	profileImage: yup.mixed(), // TODO: validate file
	// admin specific
	role: yup.string().oneOf(['superadmin', 'consultant']),
	// client specific
	holidayPayRate: yup.number(),
	AWRApplicable: yup.boolean(),
	clientID: yup.string(),
	clientName: yup.string(),
	factored: yup.string(),
	contacts: yup.array().of(
		yup.object().shape({
			name: fullName.required(),
			role: yup.string().required(),
			telephone: telephone.required(),
			email: email.required(),
		})
	),
	workingRequirements: yup.string(),
	// candidate specific
	gender: yup.string().oneOf(genders),
	hasUnspentConvictions: yup.boolean(),
	immigrationPermission: yup.boolean(),
	previousAgencies: yup.string(),
	heardAboutHumanOne: yup.string(),
	convictionsDescription: yup.string(),
	position: yup.string(),
	relationship: yup.string(),
	paymentDetails: yup.object().shape({
		available: yup.boolean().required(),
		bankName: yup.string().when('available', isTrueRequire),
		bankNameCustom: yup.string().when(['available', 'bankName'], {
			is: (available, bankName) => available && bankName === 'Other',
			then: s => s.required(),
		}),
		accountHolderName: yup.string().when('available', isTrueRequire),
		sortCode: yup.string().when('available', { is: true, then: s => s.test(sortCodeTest) }),
		accountNumber: yup.string().when('available', { is: true, then: s => s.min(8, 'Account Number must be ${min} digits long').max(8, 'Account Number must be ${max} digits long').required() }),
	}),	
	optOut48HourWorkingWeek: yup.boolean(),
	addressHistory: yup.array().of(
		addressWithCountry.concat(yup.object().shape({
			from: yup.string().nullable(),
			to: yup.string().nullable(),
		}))
	),
	dateNationalityChanged: date,
	candidateSigned: yup.string(),
	dateSurnameChanged: date,
	townCityOfBirth: yup.string(),
	jobsApplyingFor: yup.string(), 
	nationality: yup.string(),
	countryOfBirth: yup.string(),
	regionOfBirth: yup.string(),
	mothersMaidenName: yup.string(),
	nationalityChangedSinceBirth: yup.boolean(),
	birthNationality: yup.string(),
	surnameChangedSinceBirth: yup.boolean(),
	previousSurname: yup.string(),
	NINumber: yup.string().when('NINumberAvailable', { 
		is: true, 
		then: s => s.test('len', 'Must be exactly 9 characters', val => val == null || val == '' || val.length === 9) 
	}),
	NINumberAvailable: yup.boolean(),
	drivingLicenceAvailable: yup.boolean(),
	drivingLicenceNumber: yup.string(),
	// National Identity Card
	nationalIdentityCardAvailable: yup.boolean(),
	nationalIdentityCardNumber: yup.string(),
	nationalIdentityCardExpiry: yup.date().nullable(),
	// Passport
	passportAvailable: yup.boolean(),
	passportID: yup.string(),
	passportExpiry: yup.date().nullable(),
	// Visa
	visaAvailable: yup.boolean(),
	visaID: yup.string(),
	visaExpiry: yup.date().nullable(),
	// BRP
	BRPAvailable: yup.boolean(),
	BRPID: yup.string(),
	BRPExpiry: yup.date().nullable(),
	// Birth Certificate
	birthCertificateAvailable: yup.boolean(),
	birthCertificateID: yup.string(),
	// SIA Licence
	SIALicenceAvailable: yup.boolean(),
	SIALicenceType: yup.string().when('SIALicenceAvailable', isTrueRequire),
	// Food Safety Certificate
	foodSafetyCertificateAvailable: yup.boolean(),
	foodSafetyCertificateLevel: yup.string()
		.when('foodSafetyCertificateAvailable', { is: true, then: s => s.oneOf(foodSafetyCertificateLevels).required() }),
	hasHealthIssues: yup.boolean(),
	healthIssueDescription: yup.string(),
	assistanceRequired: yup.string(),
	equalOpportunitiesAgreement: yup.boolean().oneOf([true], 'This field is required'),
	dataProtectionAgreementPart1: yup.boolean().oneOf([true], 'This field is required'),
	dataProtectionAgreementPart2: yup.boolean().oneOf([true], 'This field is required'),
	employmentHistory: yup.array().of(yup.object().shape({ 
		position: yup.string(),
		companyName: yup.string(),
		datesWorked: yup.object().shape({
			from: yup.string().nullable(),
			to: yup.string().nullable(),
		}),
		duties: yup.string(),
		reasonsForLeaving: yup.string(),
		companyAddress: addressWithCountry,
		referee: yup.object().shape({
			name: yup.string(),
			position: yup.string(),
			telephone: telephone,
			email: email,
		}),
	})),
	refereeConsent: yup.boolean().oneOf([true], 'Referee consent is required'),
	employmentScheme: yup.string().oneOf(employmentSchemes).required(),
	UTRNumber: yup.string().when('employmentScheme', {
		is: v => v === 'Self Employed',
		then: s => s.required(),
	}),
}

const v = validatorPresets;

export const candidateValidationSchemas = [
	// Step 1
	yup.object().shape({
		// About you
		jobsApplyingFor: v.jobsApplyingFor,
		name: v.name,
		dateOfBirth: v.date,
		gender: v.gender,
		// Your contact details
		telephone: v.telephone,
		mobile: v.telephone,
		email: v.email.required(),
		// Emergency contact details
		emergencyContact: yup.object().shape({
			name: v.fullName,
			relationship: v.relationship,
			telephone: v.telephone,
			mobile: v.telephone,
		}),
		// Pre employment screening
		immigrationPermission: v.immigrationPermission,
		// National Identity Card
		// TODO: make card numbers and expiry required when setting available?
		nationalIdentityCardAvailable: v.nationalIdentityCardAvailable,
		nationalIdentityCardNumber: v.nationalIdentityCardNumber,
		nationalIdentityCardExpiry: v.nationalIdentityCardExpiry,
		// Passport
		passportAvailable: v.passportAvailable,
		passportID: v.passportID,
		passportExpiry: v.passportExpiry,
		// Visa
		visaAvailable: yup.visaAvailable,
		visaID: yup.visaID,
		visaExpiry: yup.visaExpiry,
		// BRP
		BRPAvailable: yup.BRPAvailable,
		BRPID: yup.BRPID,
		BRPExpiry: yup.BRPExpiry,
		// Birth Certificate
		birthCertificateAvailable: yup.birthCertificateAvailable,
		birthCertificateID: yup.birthCertificateID,
		nationality: v.nationality,
		countryOfBirth: v.countryOfBirth,
		townCityOfBirth: v.townCityOfBirth,
		regionOfBirth: v.regionOfBirth,
		mothersMaidenName: v.mothersMaidenName,
		// nationality
		nationalityChangedSinceBirth: v.nationalityChangedSinceBirth,
		birthNationality: v.birthNationality.when('nationalityChangedSinceBirth', isTrueRequire),
		dateNationalityChanged: v.dateNationalityChanged.when('nationalityChangedSinceBirth', isTrueRequire),
		// surname
		surnameChangedSinceBirth: v.surnameChangedSinceBirth,
		previousSurname: v.previousSurname.when('surnameChangedSinceBirth', isTrueRequire),
		dateSurnameChanged: v.dateSurnameChanged.when('surnameChangedSinceBirth', isTrueRequire),
		drivingLicenceAvailable: v.drivingLicenceAvailable,
		drivingLicenceNumber: v.drivingLicenceNumber.when('drivingLicenceAvailable', isTrueRequire),
		SIALicenceAvailable: v.SIALicenceAvailable,
		SIALicenceType: v.SIALicenceType,
		foodSafetyCertificateAvailable: v.foodSafetyCertificateAvailable,
		foodSafetyCertificateLevel: v.foodSafetyCertificateLevel,
		// Convictions
		hasUnspentConvictions: v.hasUnspentConvictions,
		convictionsDescription: v.convictionsDescription.when('hasUnspentConvictions', isTrueRequire),
		// Address history
		addressHistory: v.addressHistory,
		// Bank details
		paymentDetails: v.paymentDetails,
	}),
	// Step 2
	yup.object().shape({
		refereeConsent: v.refereeConsent,
		employmentScheme: v.employmentScheme,
		NINumberAvailable: v.NINumberAvailable,
		NINumber: v.NINumber,
		UTRNumber: v.UTRNumber,
		employmentHistory: v.employmentHistory,
	}),
	// Step 3
	yup.object().shape({
		previousAgencies: v.previousAgencies,
		optOut48HourWorkingWeek: v.optOut48HourWorkingWeek,
	}),
	// Step 4
	yup.object().shape({
		hasHealthIssues: v.hasHealthIssues,
		healthIssuesDescription: v.healthIssueDescription.when('hasHealthIssues', isTrueRequire),
		assistanceRequired: v.assistanceRequired.when('hasHealthIssues', isTrueRequire),
	}),
	// Step 5
	yup.object().shape({
		heardAboutHumanOne: v.heardAboutHumanOne,
		equalOpportunitiesAgreement: v.equalOpportunitiesAgreement,
		dataProtectionAgreementPart1: v.dataProtectionAgreementPart1,
		dataProtectionAgreementPart2: v.dataProtectionAgreementPart2,
		candidateSigned: v.candidateSigned,
	}),

];

const sufficientIdentityProvidedTest = {
	name: "sufficient-identity-provided",
	message: "At least one form of ID must be provided",
	test: function (value) {
		const IDKeys = [
			'nationalIdentityCardAvailable',
			'passportAvailable',
			'visaAvailable',
			'BRPAvailable',
			'birthCertificateAvailable', 
		];
		const passValues = [true, null, '', undefined]; // null || '' pass the test to wait for a user to make a selection on all IDs before executing the actual test
		for (let key of IDKeys) {
			if(passValues.includes(this.parent[key])) {
				return true;
			}
		}

		return false;
	}
}

export const registerValidationSchemas = [
	// Step 1
	yup.object().shape({
		// About you
		jobsApplyingFor: v.jobsApplyingFor,
		name: v.name,
		dateOfBirth: v.date.required(),
		gender: v.gender.required(),
		// Your contact details
		telephone: v.telephone,
		mobile: v.telephone.required(),
		email: v.email.required(),
		// Emergency contact details
		emergencyContact: yup.object().shape({
			name: v.fullName.required(),
			relationship: v.relationship.required(),
			telephone: v.telephone,
			mobile: v.telephone.required(),
		}),
		// Pre employment screening
		immigrationPermission: v.immigrationPermission.required().oneOf([true], 'You must have permission to work in the UK to continue'),
		// National Identity Card
		nationalIdentityCardAvailable: v.nationalIdentityCardAvailable.required().test(sufficientIdentityProvidedTest),
		nationalIdentityCardNumber: v.nationalIdentityCardNumber.when('nationalIdentityCardAvailable', isTrueRequire),
		nationalIdentityCardExpiry: v.nationalIdentityCardExpiry.when('nationalIdentityCardAvailable', isTrueRequire),
		// Passport
		passportAvailable: v.passportAvailable.required().test(sufficientIdentityProvidedTest),
		passportID: v.passportID.when('passportAvailable', isTrueRequire),
		passportExpiry: v.passportExpiry.when('passportAvailable', isTrueRequire),
		// Visa
		visaAvailable: v.visaAvailable.required().test(sufficientIdentityProvidedTest),
		visaID: v.visaID.when('visaAvailable', isTrueRequire),
		visaExpiry: v.visaExpiry.when('visaAvailable', isTrueRequire),
		// BRP
		BRPAvailable: v.BRPAvailable.required().test(sufficientIdentityProvidedTest),
		BRPID: v.BRPID.when('BRPAvailable', isTrueRequire),
		BRPExpiry: v.BRPExpiry.when('BRPAvailable', isTrueRequire),
		// Birth Certificate
		birthCertificateAvailable: v.birthCertificateAvailable.required().test(sufficientIdentityProvidedTest),
		birthCertificateID: v.birthCertificateID.when('birthCertificateAvailable', isTrueRequire),
		nationality: v.nationality.required(),
		countryOfBirth: v.countryOfBirth.required(),
		townCityOfBirth: v.townCityOfBirth.required(),
		regionOfBirth: v.regionOfBirth.required(),
		mothersMaidenName: v.mothersMaidenName.required(),
		// nationality
		nationalityChangedSinceBirth: v.nationalityChangedSinceBirth.required(),
		birthNationality: v.birthNationality.when('nationalityChangedSinceBirth', isTrueRequire),
		dateNationalityChanged: v.dateNationalityChanged.when('nationalityChangedSinceBirth', isTrueRequire),
		// surname
		surnameChangedSinceBirth: v.surnameChangedSinceBirth.required(),
		previousSurname: v.previousSurname.when('surnameChangedSinceBirth', isTrueRequire),
		dateSurnameChanged: v.dateSurnameChanged.when('surnameChangedSinceBirth', isTrueRequire),
		// Licences etc
		drivingLicenceAvailable: v.drivingLicenceAvailable.required(),
		drivingLicenceNumber: v.drivingLicenceNumber.when('drivingLicenceAvailable', isTrueRequire),
		SIALicenceAvailable: v.SIALicenceAvailable,
		SIALicenceType: v.SIALicenceType,
		foodSafetyCertificateAvailable: v.foodSafetyCertificateAvailable,
		foodSafetyCertificateLevel: v.foodSafetyCertificateLevel,
		// Convictions
		hasUnspentConvictions: v.hasUnspentConvictions.required(),
		convictionsDescription: v.convictionsDescription.when('hasUnspentConvictions', isTrueRequire),
		// Address history
		addressHistory: yup.array().of(
			addressWithCountryRequired.concat(yup.object().shape({
				from: yup.string().nullable().required(),
				to: yup.string().nullable().required(),
			}))
		).test(
			'min-5-years',
			'A minimum of 5 years of address history is required',
			async (values) => {
				if(!values || !values.length) 
					return false;
				
				const totalInMilliseconds = values.map(value => {
					if(!value.from || !value.to) return 0;
					const fromDate = new Date(value.from);
					const toDate = new Date(value.to);
					return toDate.getTime() - fromDate.getTime();
				}).reduce((total, n) => total + n, 0);

				const totalInYears = totalInMilliseconds / yearInMilliseconds;

				return totalInYears >= 5;
			}
		),
		// Bank details
		paymentDetails: v.paymentDetails,
	}),
	// Step 2
	yup.object().shape({
		refereeConsent: v.refereeConsent,
		employmentScheme: v.employmentScheme.required(),
		NINumberAvailable: v.NINumberAvailable.required(),
		NINumber: v.NINumber.when('NINumberAvailable', isTrueRequire),
		UTRNumber: v.UTRNumber,
		employmentHistory: yup.array().of(yup.object().shape({ 
			position: yup.string().required(),
			companyName: yup.string().required(),
			datesWorked: yup.object().shape({
				from: yup.string().nullable().required(),
				to: yup.string().nullable().required(),
			}),
			duties: yup.string().required(),
			reasonsForLeaving: yup.string().required(),
			companyAddress: addressWithCountryRequired,
			referee: yup.object().shape({
				name: yup.string().required(),
				position: yup.string().required(),
				telephone: telephone.required(),
				email: email.required(),
			}),
		}))
	}),
	// Step 3
	yup.object().shape({
		previousAgencies: v.previousAgencies.required(),
		optOut48HourWorkingWeek: v.optOut48HourWorkingWeek,
	}),
	// Step 4
	yup.object().shape({
		hasHealthIssues: v.hasHealthIssues.required(),
		healthIssuesDescription: v.healthIssueDescription.when('hasHealthIssues', isTrueRequire),
		assistanceRequired: v.assistanceRequired.when('hasHealthIssues', isTrueRequire),
	}),
	// Step 5
	yup.object().shape({
		heardAboutHumanOne: v.heardAboutHumanOne,
		equalOpportunitiesAgreement: v.equalOpportunitiesAgreement,
		dataProtectionAgreementPart1: v.dataProtectionAgreementPart1,
		dataProtectionAgreementPart2: v.dataProtectionAgreementPart2,
		candidateSigned: v.candidateSigned.required(),
	}),

]

// Helpers

export function getPresetFrom(map, key, _props={}) {
	
	var { prefix, ...props } = _props;
	
	if(!map[key])
		throw new Error(`invalid ${map.name} preset ${key}`);

	// clone fieldpreset
	const preset = cloneDeep(map[key]);

	if(typeof prefix === 'string') {
		preset.name = prefix+'.'+preset.name;
	}

	// merge props
	return extend(preset, props);

}

export function getPresetsFrom(map, presets) {
	return presets.map(preset => {
		if(typeof preset === 'string') 
			preset = [preset];
		return getPresetFrom.apply(undefined, [map, ...preset]);
	})
}

export const fieldPreset = (...args) => getPresetFrom(_fieldPresets, ...args);
export const fieldPresets = (...args) => getPresetsFrom(_fieldPresets, ...args);
export const filterPreset = (...args) => getPresetFrom(_filterPresets, ...args);
export const filterPresets = (...args) => getPresetsFrom(_filterPresets, ...args);

export function makeOptions(options) {
	if(Array.isArray(options)) {
		// covery [ <key> ] to { label: <key>, value: <key> }
		return options.map(k => ({ label: k, value: k }));
	} else {
		// converts key: value to { label: value, value: key }
		return Object.keys(options).map(k => ({
			label: options[k],
			value: k,
		}));
	}
}



// WEBPACK FOOTER //
// ./src/modules/form/form.module.js